import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const SLOTS = ["9:00 AM", "10:00 AM", "11:00 AM", "12:00 PM", "1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM", "5:00 PM", "6:00 PM"];
const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

// Next business day (Mon–Sat) or later, so the team isn't asked to call back while already on calls
export const nextBusinessDay = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  if (d.getDay() === 0) d.setDate(d.getDate() + 1);
  return ymd(d);
};
export const isSunday = (v) => v && new Date(`${v}T12:00`).getDay() === 0;
export const CONTACT_SLOTS = SLOTS;

export const ContactTimePicker = ({ value, onChange, required = false, dark = false }) => {
  const v = value || { date: "", time: "" };
  const lbl = dark ? "text-white" : "";
  return (
    <div className="grid grid-cols-2 gap-3" data-testid="contact-time-picker">
      <div>
        <Label className={lbl}>Best day to reach you{required ? " *" : ""}</Label>
        <input type="date" min={nextBusinessDay()} required={required} value={v.date}
          onChange={(e) => { if (isSunday(e.target.value)) { toast.error("We're closed Sundays — please pick Monday to Saturday"); onChange({ ...v, date: "" }); } else onChange({ ...v, date: e.target.value }); }}
          className="mt-1 w-full h-10 border border-input rounded-md px-3 text-sm bg-white text-slate-800" data-testid="contact-time-date" />
      </div>
      <div>
        <Label className={lbl}>Best time (your time){required ? " *" : ""}</Label>
        <select required={required} value={v.time} onChange={(e) => onChange({ ...v, time: e.target.value })}
          className="mt-1 w-full h-10 border border-input rounded-md px-2 text-sm bg-white text-slate-800" data-testid="contact-time-slot">
          <option value="">Pick a time</option>
          {SLOTS.map((s) => <option key={s}>{s}</option>)}
        </select>
      </div>
      <p className={`col-span-2 text-xs ${dark ? "text-slate-300" : "text-slate-500"}`}>Mon–Sat, 9 AM–7 PM, from the next business day. Our team is often on calls helping dealers, so this lets us give you our full attention.</p>
    </div>
  );
};

export const formatContactTime = (v) => (v?.date && v?.time ? `${v.date} at ${v.time} (visitor's local time)` : "");
